import { render, staticRenderFns } from "./listPage.vue?vue&type=template&id=80008d10&scoped=true"
import script from "./listPage.vue?vue&type=script&lang=js"
export * from "./listPage.vue?vue&type=script&lang=js"
import style0 from "./listPage.vue?vue&type=style&index=0&id=80008d10&prod&scoped=true&lang=css"
import style1 from "./listPage.vue?vue&type=style&index=1&id=80008d10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80008d10",
  null
  
)

export default component.exports